import { CartSpecificationLine } from "@/app/models/cart/types";
import React from "react";

export type LineItem = {
    qty: number | "";
    lengthFt: number | "";
    lengthIn: number | "";
};

type Props = {
    data?: CartSpecificationLine[];
};

const EMPTY_LINE: LineItem = { qty: "", lengthFt: "", lengthIn: "" };

function toNumOrEmpty(x: any): number | "" {
    return x === "" || x === null || x === undefined || Number.isNaN(Number(x))
        ? ""
        : Number(x);
}

function toLineItem(v: any): LineItem {
    return {
        qty: toNumOrEmpty(v?.qty),
        lengthFt: toNumOrEmpty(v?.lengthFt),
        lengthIn: toNumOrEmpty(v?.lengthIn),
    };
}

export default function CartSpecificationLinesView({ data }: Props) {
    const lines: LineItem[] =
        data?.length ? data.map(toLineItem) : [EMPTY_LINE];

    return (
        <div className="production-line-container">
            <div>
                {lines.map((line, index) => (
                    <div
                        key={index}
                        style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}
                    >
                        <div className="production-line-input-container">
                            <label style={{ marginRight: "8px" }}>Qty:</label>
                            <span style={{ fontWeight: 600 }}>
                                {line.qty} 
                            </span>
                        </div>

                        <div className="production-line-input-container">
                            <label style={{ marginRight: "8px" }}>Length:</label>
                            <span style={{ fontWeight: 600 }}>
                                {line.lengthFt}
                            </span>
                        </div>

                        <div className="production-line-input-container">
                            <label style={{ marginRight: "8px" }}>In:</label>
                               <span style={{ fontWeight: 600 }}>
                                {line.lengthIn} 
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
